import { useConversationUrl } from '@hooks/use-conversation-url';
import { useAppSelector } from '@redux/hooks';
import RfqModal from '@tkmp/rfq/components/RfqModal/RfqModal';
import { useInlineRfqForm } from '@tkmp/rfq/hooks/useInlineRfqForm/useInlineRfqForm';
import { generateDefaultField } from '@tkmp/rfq/utils';
import { IconAction } from '@tkww/orion-web-ds-action';
import React, { type FC } from 'react';
import Styles from './styles.scss';

export const StartConversation: FC = () => {
	const vendorId = useAppSelector((state) => state.vendor.vendor?.id);
	const conversationUrl = useConversationUrl(vendorId);
	const localFormContext = useInlineRfqForm({
		freeTextLabel: '',
		textAreaInitialValueOverride: generateDefaultField('textarea'),
		initiator: 'NavBar CTA',
	});

	const handleOnClick = () => {
		if (conversationUrl) {
			window.location.href = conversationUrl;
		} else {
			localFormContext.openModal();
		}
	};
	return (
		<>
			<RfqModal context={localFormContext} />
			<div className={Styles.conversationContainer}>
				<IconAction
					size="md"
					className={Styles.icon}
					aria-label="Start a chat"
					name="speech-bubble"
					onClick={handleOnClick}
				/>
			</div>
		</>
	);
};
